// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Gh4b","file":"styles_file__1AN9u"};